import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div style={styles.container} >
                <h1 style={styles.h1}>
                    Footer Here
                </h1>
            </div>
        )
    }
}


const styles = {
    container: {
        textAlign: "center",
        height: "75px",
        background: "lightblue",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        display: "none",
    }, 
    h1: {
        margin: 0,
        padding: 0,
    }
}